import Moment from 'moment'
import PropTypes from 'prop-types';
import React, { Component } from 'react';

const propTypes = {
    item: PropTypes.object,
    mandants: PropTypes.array,
    modals: PropTypes.object
}

class OverviewDetail extends Component {

    constructor(props) {
        super(props);
        this.state = {
            mandantID: this.props.item.MANDANT_ID.toString(),
        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        this.setState({ mandantID: event.target.value });
        this.props.item.MANDANT_ID = parseInt(event.target.value, 10);
        //console.log("item", this.props.item)
    }

    render() {

        return (
            <div className="e-profile">

                <div className="row">
                    <div className="col">
                        <div className="form-group">
                            <label>Číslo zakázky</label>
                            <input className="form-control" type="text"
                                name="CISLOZAKAZKY"
                                disabled={ true }
                                defaultValue={this.props.item.CISLOZAKAZKY}
                                placeholder={this.props.item.CISLOZAKAZKY || 'Číslo zakázky'} />
                        </div>
                    </div>
                    <div className="col">
                        <div className="form-group">
                            <label>Materiál</label>
                            <input className="form-control" type="text"
                                name="LAKOVNA_TYP_MATERIALU_POPIS"
                                disabled={true}
                                defaultValue={this.props.item.LAKOVNA_TYP_MATERIALU_POPIS}
                                placeholder={this.props.item.LAKOVNA_TYP_MATERIALU_POPIS || 'Materiál'} />
                        </div>
                    </div>

                    <div className="col">
                        <div className="form-group">
                            <label>Akce</label>
                            <input className="form-control" type="text"
                                name="LAKOVNA_AKCE_POPIS"
                                disabled={true}
                                defaultValue={this.props.item.LAKOVNA_AKCE_POPIS}
                                placeholder={this.props.item.LAKOVNA_AKCE_POPIS || 'Akce'} />
                        </div>
                    </div>

                    <div className="col">
                        <div className="form-group">
                            <label>Plocha</label>
                            <input className="form-control" type="text"
                                name="PLOCHA_LAKOVNA"
                                disabled={true}
                                defaultValue={this.props.item.PLOCHA_LAKOVNA} />
                        </div>
                    </div>

                </div>


                <div className="row">
                    <div className="col">
                        <div className="form-group">
                            <label>Zakázka</label>
                            <input className="form-control" type="text"
                                name="PRIJMENI"
                                disabled={true}
                                defaultValue={this.props.item.PRIJMENI}
                                placeholder={this.props.item.PRIJMENI || 'Zakázka'} />
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div className="form-group">
                            <label>Termín</label>
                            <input className="form-control" type="text"
                                name="POZADOVANY_DATUM_AKCE"
                                disabled={true}
                                defaultValue={Moment(this.props.item.POZADOVANY_DATUM_AKCE).format('DD.MM.YYYY')}
                                placeholder={this.props.item.POZADOVANY_DATUM_AKCE || 'Termín'} />
                        </div>
                    </div>
                </div>

                <div className="row" hidden={!this.props.mandants || this.props.mandants.length === 1 || !this.props.modals.confirm}>
                    <div className="col">
                        <div className="form-group">
                            <label>Lakýrník</label>
                            <select className="form-control" value={this.state.mandantID} name="MANDANT_ID" onChange={this.handleChange}>
                                {this.props.mandants.map((mandant) =>
                                    <option value={mandant.MANDANT_ID.toString()} key={mandant.MANDANT_ID.toString()}>{mandant.NAZEV}</option>
                                )}
                            </select>
                        </div>
                    </div>

                    <div className="col-md-4">
                    </div>
                </div>

                <div hidden={!this.props.item.ErrorMessage}>
                    <div className="row">
                        <div className="col">
                            <br className="my-3" />
                            <h5 className="text-danger">{this.props.item.ErrorMessage}</h5>
                        </div>

                    </div>

                </div>

                

            </div>
        )
    }
}

OverviewDetail.propTypes = propTypes

export default OverviewDetail
